
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard } from '@fortawesome/free-solid-svg-icons'

import MenuIcon from '@mui/icons-material/Menu'
import _AppBar from '@mui/material/AppBar'

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import {
  Link,
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom"
import Select from 'react-select'

import config from 'config'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import { AppCtx } from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  SchedulesCtx,
} from '$src/components/schedules'

library.add( faCreditCard, )


/*
 * BankTabs
**/
const BankTabs = (props) => {

  const params = useParams()

  /* ctx */

  const {
    actionName,
    loading,    setLoading,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in BankTabs')

  const {
    activeBankTab, setActiveBankTab,
  } = useContext(BanksCtx)

  const bankTabs = {
    'schedules': { key: C.bankTabs.schedules,
      label: 'Financial Data View',
      link: appRouter.bankSchedulePath({ bank_rssd: params.rssd }),
    },
    'contacts': { key: C.bankTabs.contacts,
      label: 'Contacts',
      link: appRouter.bankContactsPath(params),
    },
  }

  if (['banks#schedule', 'banks#contacts'].indexOf(actionName) === -1) { return }

  return <div className='BankTabs' >
    { Object.keys(bankTabs).map((tab, idx) => <F key={idx} >
      <Link to={bankTabs[tab].link}
            onClick={() => setActiveBankTab(tab) }
      ><div key={idx}
            className={`Tab ${activeBankTab===tab ? 'active' : ''}`}
      >
        { bankTabs[tab].label }
      </div></Link>
    </F>) }
  </div>
}
export default BankTabs
